import axios from "axios"

const rootUrl = process.env.REACT_APP_API_ROOT_URL
const catApi = rootUrl + "/token"

export const tokenAPI = async (token) => {
  try {
    const { data } = await axios.get(catApi, {
      headers: { Authorization: token },
    })

    return data
  } catch (error) {
    return (
      error.response?.data || {
        status: "error",
        message: "Something went wrong",
      }
    )
  }
}
